import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const createPreviewStmtInstruction = `
#### Create preview

- Syntax: \`create preview <preview_name> for <entity_name>;\`
- Example: \`create preview OptionPreview for Option;\`
- Example: \`create preview VariantPreview for Variant;\`

#### Add preview to form

- Syntax: \`add preview <preview_name> in <form_name>.<field_name> for <entity_name>;\`
- Example: \`add preview OptionPreview in ProductForm.options for Option;\`
- Example: \`add preview VariantPreview in ProductForm.variants for Variant;\`
`;
export const stmtCreatePreview = ({ previewName, formName, fieldName, entityName }) => {
    if (formName && fieldName) {
        return `create preview ${previewName} in ${formName}.${fieldName} for ${entityName};`;
    }
    return `create preview ${previewName} for ${entityName};`;
};
export const stmtAddPreview = ({ previewName, formName, fieldName, entityName }) => {
    if (formName && fieldName) {
        return `add preview ${previewName} in ${formName}.${fieldName} for ${entityName};`;
    }
    return `add preview ${previewName} for ${entityName};`;
};
export const createPreviewHandler = createStructureStatementHandler({
    type: 'add preview',
    parse: line => {
        const match = /^(add|create) preview (?<previewName>\w+)( in (?<formName>\w+).(?<fieldName>\w+))? for (?<entityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'add preview',
                previewName: match.groups.previewName,
                formName: match.groups.formName,
                fieldName: match.groups.fieldName,
                entityName: match.groups.entityName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addPreview({
                previewName: stmt.previewName,
                formName: stmt.formName,
                fieldName: stmt.fieldName,
                entityName: stmt.entityName,
            });
        });
    },
});
//# sourceMappingURL=CreatePreviewStmt.js.map